/* eslint-disable react/prop-types */
import React from 'react';

const PatientFilesHeader = ({ requireVisit = true }) => (
    <div className="patient-files__header">
        <div>
            <h1 className="patient-files__title">Patient files</h1>
            <p className="patient-files__subtitle">
                {requireVisit
                    ? 'Lab reports, imaging, prescriptions, and other documents for this visit.'
                    : 'Lab reports, imaging, prescriptions, and other documents for this patient (S3 medical files).'}
            </p>
        </div>
    </div>
);

export default PatientFilesHeader;
